import { render, staticRenderFns } from "./orderRange.vue?vue&type=template&id=638ff944"
import script from "./orderRange.vue?vue&type=script&lang=js"
export * from "./orderRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports